import React from "react";
import "./ContactUs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faExclamationCircle,
  faMessage,
  faPhone,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

const ContactUs = () => {
  return (
    <div className="full-content">
      <section className="contact-hero ">
        <div className="animate-fadein ">
        <h1>Contact Us</h1>
        <p>Contact us — we’re here to make fashion fun and easy!</p>
        </div>
      </section>
      <div class="form-divider-line"></div>
      <section className="contact-main">
        <div className="contact-info">
          <h2>Get Your Perfect Outfit Quote Instantly!</h2>
          <p className="highlight">
            Discover your style with ease — no waiting, just fashion at your
            fingertips.
          </p>
          <p>
            From casual to Liv_minus, we’ve got looks that fit your vibe and
            budget. Let’s create your wardrobe magic today!
          </p>
          <div className="phone">
            <FontAwesomeIcon icon={faPhone} className="phone-logo" />

            <strong>+91 9739620009 — Your style team is ready to help!</strong>
          </div>
        </div>

        <form className="contact-form">
          <div className="input-group">
            <FontAwesomeIcon icon={faUser} className="icon" />
            <input type="text" placeholder="Name" />
          </div>

          <div className="input-group">
            <FontAwesomeIcon icon={faPhone} className="icon" />
            <input type="tel" placeholder="Phone" />
          </div>

          <div className="input-group">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <input type="email" placeholder="Email Address" />
          </div>

          <div className="input-group">
            <FontAwesomeIcon icon={faExclamationCircle} className="icon" />
            <input type="text" placeholder="Subject" />
          </div>

          <div className="input-group">
            <FontAwesomeIcon icon={faMessage} className="last-icon" />
            <textarea placeholder="How can we help you? Feel free to get in touch!" />
          </div>

          <button type="submit">Submit</button>
        </form>
      </section>
      <div class="form-divider-line"></div>
    </div>
  );
};

export default ContactUs;
